import { IonCard, IonCardContent, IonCol, IonRow, IonSelectOption } from '@ionic/react';
import { callOutline, locationOutline, mailOutline, personOutline, phoneLandscapeOutline, phonePortraitOutline, readerOutline } from 'ionicons/icons';

import InputItem from '../../components/input/InputItem';
import SlideContent from '../../components/slide-content/SlideContent';
import RadioItem from '../../components/radio/RadioItem';

interface Props {
    formProvider: any,
    data: any,
}

const Section2: React.FC<Props> = (props) => {
    let provinceIndex = props.data.provinces?.findIndex((item: any) => {
        return item.name == props.formProvider.form.province.value
    })

    const onProvinceChange = () => {
        let form = { ...props.formProvider.form }
        form.city.value = '';

        props.formProvider.setForm(form)
    }

    return <SlideContent type="navbar">
        <IonCard>
            <IonCardContent>
                <IonRow>
                    <IonCol>
                        <InputItem name="full_name" type="text" label="نام و نام خانوادگی" icon={personOutline} maxlength={25} provider={props.formProvider} />

                        <InputItem name="province" type="select2" label="استان" icon={locationOutline} provider={props.formProvider} change={onProvinceChange}>
                            {props.data.provinces?.map((item: any) => {
                                return <RadioItem key={`cart-province-${item.name}`} value={item.name} label={item.name}/>
                            })}
                        </InputItem>

                        <InputItem name="city" type="select2" label="شهر" icon={locationOutline} provider={props.formProvider}>
                            {props.data.provinces && Object(props.data.provinces[provinceIndex]).Cities?.map((item: any) => {
                                return <RadioItem key={`cart-city-${item.name}`} value={item.name} label={item.name}/>
                            })}
                        </InputItem>

                        <InputItem name="address" type="textarea" label="آدرس" icon={locationOutline} maxlength={100} provider={props.formProvider} />

                        <InputItem name="mobile" type="tel" label="تلفن همراه" icon={phonePortraitOutline} maxlength={11} spaced ltr provider={props.formProvider} />

                        <InputItem name="postal_code" type="text" label="کد پستی" icon={readerOutline} maxlength={10} spaced ltr provider={props.formProvider} />

                        <InputItem name="telephone" type="tel" label="تلفن ثابت (به همراه کد شهرستان)" icon={callOutline} maxlength={11} ltr provider={props.formProvider} />
                    </IonCol>
                </IonRow>
            </IonCardContent>
        </IonCard>
    </SlideContent>
}

export default Section2